const requestState = {
    initial: 'initial',
    serverError: 'serverError',
    internetConnection: 'internetConnection',
    haveData: 'haveData',
    invalidTokne: 'invalidToken',
}


export { requestState, };